import React from 'react';
import { LogRow, UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

export const RawLog: React.FC<Omit<UserActionLog, 'url'>> = ({ body }) => {
  const keyValues = Object.keys(body).map(key => {
    return { key, value: body[key] };
  });

  return (
    <>
      {body && (
        <>
          {keyValues.map((data, i) => (
            <LogRow field={data.key} value={data.value} key={i} />
          ))}
        </>
      )}
    </>
  );
};
